import type { FaireProductEntity } from "../../entity_types/product";

export const p_c6457xt61l: FaireProductEntity = {
  token: "p_c6457xt61l",
  type: "product",
  name: "Cozy Cabin \u2013 34oz Fall Winter Strong Scented Jar Candle",
  brandName: "A Cheerful Giver",
  imageUrl:
    "https://cdn.faire.com/fastly/5752c5eaaa69db583496af714cf4dfd0d5d23afac1eec64e5745ce0526ddc3b0.jpeg",
  priceDollars: 14,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/01445ab68cd1e9a4c43add01029bc847f5348fd895c09179ee6120ce113642bd.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
